import { supabase } from '../lib/supabase';

export const avatarService = {
  // Upload avatar and update user profile
  async uploadAvatar(userId, file) {
    try {
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      if (!allowedTypes?.includes(file?.type)) {
        throw new Error('Invalid file type. Please upload a JPEG, PNG, or WebP image.');
      }

      // Validate file size (2MB max)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file?.size > maxSize) {
        throw new Error('File size too large. Maximum size is 2MB.');
      }

      // Generate unique file name with timestamp
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const filePath = `${userId}/${fileName}`;

      // Upload to Supabase storage
      const { data: uploadData, error: uploadError } = await supabase?.storage?.from('avatars')?.upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (uploadError) throw uploadError;

      // Update user profile with new avatar path
      const { error: updateError } = await supabase?.from('user_profiles')?.update({ avatar_url: filePath })?.eq('id', userId);

      if (updateError) throw updateError;

      return { filePath, success: true };
    } catch (error) {
      console.error('Error uploading avatar:', error);
      throw error;
    }
  },

  // Get signed URL for avatar (private bucket requires signed URLs)
  async getAvatarUrl(filePath) {
    try {
      if (!filePath) return null;

      const { data, error } = await supabase?.storage?.from('avatars')?.createSignedUrl(filePath, 3600); // 1 hour expiry

      if (error) throw error;

      return data?.signedUrl || null;
    } catch (error) {
      console.error('Error getting avatar URL:', error);
      return null;
    }
  },

  // Delete old avatar when uploading new one
  async deleteAvatar(filePath) {
    try {
      if (!filePath) return;

      const { error } = await supabase?.storage?.from('avatars')?.remove([filePath]);

      if (error) throw error;
    } catch (error) {
      console.error('Error deleting avatar:', error);
      // Don't throw - deletion failure shouldn't block upload
    }
  }
};